import { Stack } from '@chakra-ui/react';
import type { Contributor as ContributorProps } from 'types/cms/blog/Contributors';

import { BlogSectionHeading } from '../BlogSectionHeading';
import { Contributor } from './Contributor';

export const Contributors = ({
  title,
  contributors,
}: {
  title: string;
  contributors: ContributorProps[];
}) => (
  <Stack spacing="2xs">
    <BlogSectionHeading id="contributors">{title}</BlogSectionHeading>
    {contributors.map((contributor, i) => (
      <Contributor key={i} contributor={contributor} />
    ))}
  </Stack>
);
